import services from 'services/services';
import { withToastManager } from 'react-toast-notifications';
import people_service from 'services/people';
import React from 'react';
import { Flex, Box, Button } from 'rebass';
import { Textarea, Label, Input, Select, Checkbox } from '@rebass/forms';
import { PERSON_KEY_TYPES } from 'utils/constants';
import { FiXCircle, FiPlus, FiUsers } from 'react-icons/fi';
import ListWrapper from 'components/ListWrapper';
import ItemWrapper from 'components/ItemWrapper';
import TooltipIcon from 'components/TooltipIcon';
import ReactTooltip from 'react-tooltip';
import ReactModal from 'react-modal';
import ReactModalActions from 'components/ReactModalActions';
import H1 from 'components/H1';
import NiceModal from 'components/NiceModal';

class CreatePersonDataKey extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: props.placeholder ? props.placeholder : '',
            type: 'string',
            definition: [],
            error_text: '',
            ...this.props.edit,
            bulkProperties: [],
            showBulkModal: false
        };

        this.submit = this.submit.bind(this);
    }

    isValid() {
        const title = this.state.title.trim();

        if (title.length == 0 || !this.state.type) {
            return false;
        }
        return true;
    }

    addDefinitionItem(label, value) {
        let d = this.state.definition;
        d.push({ label: label, value: value, creating: 1 });
        this.setState({definition: d});
    }

    addOptionsBulk(e) {
        e.preventDefault();
        this.setState({showBulkModal: false});

        const that = this;
        let new_options = [];

        if (this.state.bulkProperties) {
            let arr = this.state.bulkProperties.split(/\r?\n/);
            if (arr.length) {
                arr.forEach(text_line => {
                    text_line = text_line.trim();
                    if (text_line && text_line.length > 0) {
                        new_options.push({
                            label: text_line,
                            value: text_line,
                            creating: 1
                        });
                    }
                })

                let d = this.state.definition;
                d = d.concat(new_options);
                console.log(d, new_options)
                this.setState({definition: d, bulkProperties: []});
            }
        }
    }

    insertUniqueColumnValuesXHR() {
        const { toastManager } = this.props;
        const that = this;
        //setEditColumnLoading(true);
        people_service
            .getUniqueColumnValues(this.state.id)
            .then((columnValues) => {
                toastManager.add('Successfully found column values', {
                    appearance: 'success',
                    autoDismiss: true
                });
                //console.log(columnValues);
                columnValues.forEach(unique_column_value => {
                    const found_existing = that.state.definition.find(d => d.value == unique_column_value);
                    if (!found_existing) {
                        that.addDefinitionItem(unique_column_value, unique_column_value);
                    } else {
                        console.log('skipping ', found_existing)
                    }
                })
            })
            .catch(error => {
                console.log(error);
                const error_text = services.parseXhrErrors(error);
                toastManager.add(error_text, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }


    updateColumnXHR(column) {
        const { toastManager } = this.props;
        const that = this;
        //setEditColumnLoading(true);
        people_service
            .updateColumn({
                id: column.id,
                title: column.title,
                definition: column.definition,
                type: column.type,
                options_az:  this.state.options_az,
            })
            .then((savedColumn) => {
                toastManager.add('Successfully saved column', {
                    appearance: 'success',
                    autoDismiss: true
                });
                that.props.onSuccess(savedColumn);
            })
            .catch(error => {
                const error_text = services.parseXhrErrors(error);
                toastManager.add(error_text, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    submit(e) {
        e.preventDefault();
        this.setState({ error_text: '' });
        const that = this;
        const { toastManager } = this.props;

        if (this.state.id) {
            this.updateColumnXHR(this.state);
        } else {
            
            services
                .postCustomDataColumnsXHR({
                    title: this.state.title,
                    type: this.state.type,
                    definition: this.state.definition,
                    options_az:  this.state.options_az,
                })
                .then(customDataColumn => {
                    that.props.onSuccess(customDataColumn);
                    toastManager.add('Successfully created property', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                })
                .catch(error => {
                    const error_text = services.parseXhrErrors(error);
                    toastManager.add(error_text, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        }
    }

    render() {
        let definition = this.state.definition;
        /*if (this.state.options_az && definition && definition.length) {
            definition.sort(function(a, b) {
                a = a.label.toUpperCase();
                b = b.label.toUpperCase();

                // equal items sort equally
                if (a === b) {
                    return 0;
                }
                // nulls sort after anything else
                else if (!a) {
                    return 1;
                }
                else if (!b) {
                    return -1;
                }
                // otherwise, if we're ascending, lowest sorts first
                else {
                    return a < b ? -1 : 1;
                }
            });
        }*/

        return (
            <form onSubmit={this.submit}>
                {this.state.error_text && (
                    <Box mb={2} style={{ color: 'red' }}>
                        {this.state.error_text}
                    </Box>
                )}

                <Label htmlFor="add_custom_column_title">Title</Label>
                <Input
                    type="text"
                    mb={3}
                    required
                    autoFocus
                    autoComplete="off"
                    name="add_custom_column_title"
                    placeholder="Nationality"
                    value={this.state.title}
                    onChange={e => this.setState({ title: e.target.value })}
                    required
                />

                <Label htmlFor="add_custom_column_type">Type</Label>
                <Select
                    mb={3}
                    name="add_custom_column_type"
                    value={this.state.type}
                    onChange={e => this.setState({ type: e.target.value })}
                    //disabled={this.state.id ? true : false}
                >
                    {PERSON_KEY_TYPES.map(pkt => <option value={pkt.type}>{pkt.title}</option>)}
                </Select>

                { (this.state.type == 'dropdown' || this.state.type == 'checkbox') && 
                    <>
                        <Label>Options</Label>
                        <ListWrapper
                            style={{
                                position: 'relative',
                                border: '1px solid #eee',
                                borderRadius: '4px'
                            }}
                        >
                            <ItemWrapper className='header-row-dark' style={{padding: '8px 16px', minHeight: '32px'}}>
                                <Box width={1 / 2}>
                                    Label
                                    <TooltipIcon for={`tooltip-label`} margin="0px 0 0 4px" />
                                </Box>
                                <Box width={1 / 2}>
                                    Value
                                    <TooltipIcon for={`tooltip-value`} margin="0px 0 0 4px" />
                                </Box>
                            </ItemWrapper>
                            { definition.map(d => {
                                
                                if (!d) { return; }

                                return <ItemWrapper style={{ color: 'black' }}>
                                    <Box width={1/2} style={{paddingRight: '16px'}}>
                                        <Input value={d.label} onChange={(e) => {
                                            let defs = this.state.definition;
                                            const index = defs.indexOf(d);
                                            if (index > -1) {
                                                defs[index].label = e.target.value;
                                                this.setState({definition: defs});
                                            }
                                            
                                        }} required />
                                    </Box>
                                    <Box width={1/2}>
                                        <Flex>
                                            <Input value={d.value} mr={3}
                                                onChange={(e) => {
                                                    let defs = this.state.definition;
                                                    const index = defs.indexOf(d);
                                                    if (index > -1) {
                                                        defs[index].value = e.target.value;
                                                        this.setState({definition: defs});
                                                    }
                                                }}
                                                disabled={!d.creating}
                                                required
                                            />
                                            <Button type='button' variant='transparent' onClick={() => {
                                                const defs = this.state.definition;
                                                const index = defs.indexOf(d);
                                                //console.log(defs, index)
                                                if (index > -1) {
                                                    defs.splice(index, 1);
                                                    this.setState({definition: defs});
                                                }
                                            }}><FiXCircle /></Button>
                                        </Flex>
                                    </Box>
                                </ItemWrapper>
                            })}
                            <ItemWrapper style={{ border: 0, flexDirection: 'column', alignItems: 'flex-start' }}>

                            
                                <Button type='button' variant='transparent' onClick={e => { this.addDefinitionItem('', ''); }}><FiPlus/> Add option</Button>
                                <Button type='button' variant='transparent' onClick={e => this.setState({ showBulkModal: true}) }><FiPlus/> Add bulk</Button>
                                

                                {this.state.id && 
                                    <>
                                        <br/>
                                        <Button type='button' variant='transparent' onClick={(e) => this.insertUniqueColumnValuesXHR()}>
                                            <FiUsers /> Populate options using panelist data
                                        </Button>
                                    </>
                                }
                            </ItemWrapper>

                            <ReactTooltip id={`tooltip-label`} effect="solid" place="top" place={'right'} multiline={true} style={{maxWidth: '200px'}}>
                                This will show up as the selectable value.
                            </ReactTooltip>
                            <ReactTooltip id={`tooltip-value`} effect="solid" place="top" multiline={true} style={{maxWidth: '200px'}}>
                                This is the actual value stored in the DB,<br/>
                                and it can be different from the "Label".<br/>
                                (e.g. Label = California, then Value = CA)
                            </ReactTooltip>
                        </ListWrapper>

                        <Box mt={3}>
                            {/*<Input
                                mb={3}
                                required
                                autoFocus
                                autoComplete="off"
                                name="add_custom_column_title"
                                placeholder="Nationality"
                                value={this.state.title}
                                onChange={e => this.setState({ title: e.target.value })}
                                required
                            />*/}
                            <Label style={{ width: '250px', cursor: 'pointer' }}>
                                <Checkbox
                                    name="options_az"
                                    checked={this.state.options_az == 1}
                                    onChange={e => this.setState({ options_az: e.target.checked })}
                                />
                                <span style={{ padding: '4px 0 0 0' }}>
                                    Sort options alphabetically
                                </span>
                            </Label>
                        </Box>
                    </>
                }

                <Box className={`modal-actions ${this.state.id ? 'modal-actions-sticky' : ''}`}>


                    <Button type="button" variant="secondary-gray" mr={3} onClick={this.props.onClose}>
                        Cancel
                    </Button>

                    <Button type="submit" mr={0} className='modal-primary'>
                        {this.state.id ? 'Update' : 'Create'} property
                    </Button>

                </Box>
                <NiceModal
                    isOpen={this.state.showBulkModal}
                    shouldCloseOnOverlayClick
                    onRequestClose={()=> this.setState({ showBulkModal: false}) }
                    title={`Add bulk properties`}
                >
                    <Box>
                        <Label>Use a new line for each property</Label>
                        <Textarea autoFocus
                            value={this.state.bulkProperties}
                            onChange={e => this.setState({bulkProperties: e.target.value})}
                            height={'120px'}
                            />
                    </Box>
                    <Box className='modal-actions'>
                        <Button type="button" variant="secondary-gray" mr={3}
                            onClick={() => this.setState({ showBulkModal: false})}
                        >Cancel</Button>
                        <Button type="submit" variant="primary" className="modal-primary" mr={0} onClick={e => this.addOptionsBulk(e)}>Add properties</Button>
                    </Box>
                </NiceModal>
            </form>
        );
    }
}

export default withToastManager(CreatePersonDataKey);
